import { MdNotes } from 'react-icons/md';
import SectionLabelWithIcon from 'components/typography/SectionLabelWithIcon';

export default function TermsAndConditions({ xMargins = {}, marginTop = {} }) {
  return (
    <>
      <SectionLabelWithIcon
        label="Terms & Conditions"
        icon={<MdNotes />}
        iconClassName="text-2xl"
        style={{
          paddingBottom: '1rem',
          borderBottomWidth: '1px',
          ...xMargins,
          ...marginTop,
        }}
        isPdf
      />
      <p style={{ marginTop: '1rem', marginBottom: '1rem', ...xMargins }}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sem augue,
        dictum id pharetra quis, elementum quis enim. Nulla id lacinia sem,
        malesuada feugiat eros. Fusce nec turpis commodo, vehicula lorem rutrum,
        dictum neque. Fusce imperdiet libero nunc, ac cursus ex aliquam at.
        Mauris vel finibus est. Phasellus elementum scelerisque ultricies.
        Aliquam nec elit ipsum. Cras dui orci, tincidunt eu ex sed, suscipit
        interdum tellus. Pellentesque egestas turpis quis feugiat sodales. Proin
        auctor tincidunt elit, in sodales lacus semper consequat. Curabitur
        sodales libero in enim ultrices imperdiet. Duis ac sagittis diam.
      </p>
      <p style={{ marginTop: '1rem', marginBottom: '1rem', ...xMargins }}>
        Vivamus egestas purus viverra vestibulum ornare. Sed sagittis massa
        tortor, nec euismod dui convallis quis. Quisque ipsum lacus, bibendum ut
        lorem nec, aliquam gravida nunc. Integer ullamcorper iaculis felis, ac
        hendrerit mauris placerat vel. Maecenas arcu massa, sollicitudin id
        nulla non, efficitur euismod lectus. Mauris luctus consequat nibh. Nunc
        convallis sit amet dolor quis volutpat. Praesent pellentesque pulvinar
        tellus, eget pretium justo molestie in. Suspendisse imperdiet magna ut
        posuere molestie. Suspendisse ullamcorper accumsan eros in dignissim.
        Aenean semper orci purus, in ultrices dolor scelerisque eget.
      </p>
      <p
        style={{
          marginTop: '1rem',
          marginBottom: '3rem',
          ...xMargins,
        }}
      >
        Quisque et ex leo. In elementum neque eu elementum volutpat.
        Pellentesque risus nunc, aliquam quis arcu quis, vestibulum laoreet
        turpis. Suspendisse bibendum, mauris nec pellentesque ornare, ante eros
        maximus nulla, sed dapibus sem dolor ut dui. Proin molestie metus non
        placerat hendrerit. Quisque nulla lorem, iaculis ut lorem sit amet,
        aliquam convallis lorem.{' '}
      </p>
    </>
  );
}
